import { useHotkeySequence } from "@tanstack/react-hotkeys";
import Logger from "@/lib/logger.ts";

export default function useToggleLogger() {
    useHotkeySequence(["D", "D"], () => (Logger.enabled = !Logger.enabled), { ignoreInputs: true, timeout: 200 });
}
